import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import '../../../../filters';

export default {
  name: 'OmSelectMaintenance',
  mixins: [validationMixin],
  components: {
    
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      maintenances: [],
      maintenance: { text: '', value: '' },
      message: '',
    }
  },
  validations: {
    maintenanceValue: {
      required
    },
  },
  watch: {
    maintenance: function (value) {
      if (!value)
        return;
      this.dataObj.appData.maintenanceId = parseInt(value.value);
    },
  },
  created() {
    this.$root.$on('om_select_maintenance_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.maintenances = this.dataObj.appData.maintenances;
      });
    },
    setSelectedMActivity(code) {
      console.log(code);
    },
  },
  
}

